import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2StarterPackageTeaserDialogProperties extends BasicDialogProperties {
    public timeleft: number = 0;

    constructor(timeleft: number) {
        super();

        this.timeleft = timeleft;
    }
}
